import { ChangeDetectionStrategy, Component, Signal, inject } from '@angular/core';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { HdDocViewerComponent } from './hd-doc-viewer.component';
import { HdDocRef } from './hd-doc-ref.model';

/**
 * Floating-panel-wrapper voor {@link HdDocViewerComponent}. Wordt door de
 * {@link FloatingPanelService} dynamisch gemount; leest de via DI doorgegeven
 * `FLOATING_PANEL_DATA` (de initiële {@link HdDocRef}) en geeft die door.
 *
 * Spiegelt {@link HdCircuitInfoPanelComponent}: de viewer-component zelf blijft
 * herbruikbaar buiten een floating-panel context.
 */
@Component({
  selector: 'hd-doc-viewer-panel',
  template: `<hd-doc-viewer [initialRef]="data()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdDocViewerComponent],
})
export class HdDocViewerPanelComponent {
  protected readonly data = inject(FLOATING_PANEL_DATA) as Signal<HdDocRef>;
}
